import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import PublisherLoginPage from "./pages/PublisherLoginPage";
import PublisherDashboard from "./pages/PublisherDashboard";
import StaffDashboard from "./pages/StaffDashboard";
import GroupedApplicationsDeputy2 from "./pages/GroupedApplicationsDeputy2";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ErrorReviewPage from "./pages/ErrorReviewPage";
import FinalDecisionPage from "./pages/FinalDecisionPage";
import TekserisPage from "./pages/TekserisPage";
import ContractVerifyPage from "./pages/ContractVerifyPage";
import NewOrderCreate from "./pages/NewOrderCreate";

import OrderList from './pages/OrderList';
import ContractCreate from './pages/ContractCreate'; // жолды тексеріңіз
import ContractDetail from './pages/ContractDetail';





import PrivateRoute from "./components/PrivateRoute";
import { startSessionWatcher } from "./utils/sessionWatcher";


function App() {
  const locale = localStorage.getItem("locale") || "kz";

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) return;

    const stopWatcher = startSessionWatcher(120); // тест: 2 минуты
    // const stopWatcher = startSessionWatcher(120); // продакшен: 2 часа

    return () => stopWatcher();
  }, []);

  return (
    <Router>
      <Routes>

        {/* Бұйрықтарға арналған роуттар */}
        <Route path="/orders" element={<OrderList />} />
        <Route path="/staff-groups/new-order/:id" element={<NewOrderCreate />} />
        {/* Динамикалық ID арқылы бұйрықты ашу/көру режимі */}
        <Route path="/orders/:id" element={<NewOrderCreate />} />
        <Route path="/contracts/verify" element={<ContractVerifyPage />} />
        <Route path="/tekseris" element={<TekserisPage />} />
        // Routes ішінде:
<Route path="/contracts/create" element={<ContractCreate />} />
{/* <Route path="/contracts/:id" element={<ContractDetails />} /> */}
<Route path="/contracts/:id" element={<ContractDetail />} />
        <Route path="/error-review/:id/:bookId" element={<ErrorReviewPage locale={locale} />} />
        <Route path="/error-review/:id/:bookId?" element={<ErrorReviewPage locale={locale} />} />
        <Route path="/applications/:id/:bookId/edit" element={<ErrorReviewPage locale={locale} />} />
        <Route path="/applications/:id" element={<ErrorReviewPage locale={locale} />} />

        <Route path="/final-decision/:id" element={<FinalDecisionPage />} />

        {/* Ашық беттер */}

        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/publisher/login" element={<PublisherLoginPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* Қорғалған беттер */}
        <Route element={<PrivateRoute />}>
          <Route path="/orders" element={<OrderList />} />
          <Route
            path="/staff-groups/new-order/:id"
            element={<NewOrderCreate />}
          />
          <Route path="/orders/:id" element={<NewOrderCreate />} />
          <Route path="/contracts/verify" element={<ContractVerifyPage />} />
          <Route path="/tekseris" element={<TekserisPage />} />

          <Route
            path="/error-review/:id/:bookId"
            element={<ErrorReviewPage locale={locale} />}
          />
          <Route
            path="/error-review/:id/:bookId?"
            element={<ErrorReviewPage locale={locale} />}
          />
          <Route
            path="/applications/:id/:bookId/edit"
            element={<ErrorReviewPage locale={locale} />}
          />
          <Route
            path="/applications/:id"
            element={<ErrorReviewPage locale={locale} />}
          />

          <Route path="/final-decision/:id" element={<FinalDecisionPage />} />
          <Route path="/publisher-dashboard" element={<PublisherDashboard />} />
          <Route path="/staff-groups" element={<StaffDashboard />} />
          <Route
            path="/expertise/deputy2/groups"
            element={<GroupedApplicationsDeputy2 />}
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;